// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t0z0","type":"styles_type__1jW0r","choices":"styles_choices__22soZ"};